<template>
  <TimeslotDashboardLayout>
    <div class="main-content support">
      <div>
        <div class="content-div">
          <div class="tap-heading-div">
            <h1 class="tab-heading">Notifications</h1>
            <div class="tab-text"></div>
          </div>
        </div>
      </div>

      <div class="notifications-wrapper">
        <div class="no-update_wrapper" v-if="notifications.length === 0">
          <div class="no-update_content">
            <img
              src="@/assets/timeslot-images/notification1.svg"
              loading="lazy"
              alt=""
              width="50"
              height="50"
            />
            <div class="no-update-yet">Nothing to show here</div>
            <div class="appointments">
              <strong>Notifications would show up here</strong>
            </div>
            <router-link
              to="/discover-professionals"
              class="explore-professionals_button w-button"
              >Explore professionals</router-link
            >
          </div>
        </div>
        <div
          class="content-1 extra"
          v-for="(notification, index) in notifications"
          :key="index"
          @click="view(notification)"
          v-else
        >
          <div class="notification-div">
            <img
              :src="
                notification.customerDisplayPicture ||
                  require('@/assets/timeslot-images/profileImg.svg')
              "
              loading="lazy"
              width="41"
              alt=""
              class="image-22"
            />
            <div
              class="text-block-78"
              v-if="
                notification.notificationModule.toLowerCase() ===
                  'message request' &&
                  notification.notificationAction.toLowerCase() === 'accept'
              "
            >
              Message request accepted by
              <a href="#" class="link-17">{{ notification.customerName }}</a>
            </div>
            <div
              class="text-block-78"
              v-if="
                notification.notificationModule.toLowerCase() ===
                  'message request' &&
                  notification.notificationAction.toLowerCase() === 'decline'
              "
            >
              Message request declined by
              <a href="#" class="link-17">{{ notification.customerName }}</a>
            </div>
            <div
              class="text-block-78"
              v-if="notification.notificationModule.toLowerCase() === 'booking'"
            >
              Booking confirmed by
              <a href="#" class="link-17">{{ notification.customerName }}</a>
            </div>
            <div
              class="text-block-78"
              v-if="
                notification.notificationModule.toLowerCase() === 'message' &&
                  notification.notificationAction.toLowerCase() === 'create'
              "
            >
              Message sent by
              <a href="#" class="link-17">{{ notification.customerName }}</a>
            </div>
            <div
              class="text-block-78"
              v-if="
                notification.notificationModule.toLowerCase() ===
                  'subscription' &&
                  notification.notificationAction.toLowerCase() === 'create'
              "
            >
              Subscription accepted by
              <a href="#" class="link-17">{{ notification.customerName }}</a>
            </div>
            <div
              class="text-block-78"
              v-if="
                notification.notificationModule.toLowerCase() ===
                  'subscription' &&
                  notification.notificationAction.toLowerCase() === 'create'
              "
            >
              Subscription accepted by
              <a href="#" class="link-17">{{ notification.customerName }}</a>
            </div>
            <div
              class="text-block-78"
              v-if="
                notification.notificationModule.toLowerCase() ===
                  'subscription' &&
                  notification.notificationAction.toLowerCase() === 'success'
              "
            >
              Subscription to
              <a href="#" class="link-17">{{ notification.customerName }}</a>
              successful
            </div>
            <div
              class="text-block-78"
              v-if="
                notification.notificationModule.toLowerCase() ===
                  'subscription' &&
                  notification.notificationAction.toLowerCase() === 'approve'
              "
            >
              Subscription declined by
              <a href="#" class="link-17">{{ notification.customerName }}</a>
            </div>
            <div
              class="text-block-78"
              v-if="
                notification.notificationModule === 'Subscription' &&
                  notification.notificationAction.toLowerCase() === 'decline'
              "
            >
              Subscription declined by
              <a href="#" class="link-17">{{ notification.customerName }}</a>
            </div>
            <div
              class="text-block-78"
              v-if="
                notification.notificationModule.toLowerCase() ===
                  'subscription' &&
                  notification.notificationAction.toLowerCase() ===
                    'failed renewal'
              "
            >
              Renew subscription to
              <a href="#" class="link-17">{{ notification.customerName }}</a>
            </div>
          </div>
          <div
            class="unread"
            v-if="notification.notificationStatus.toLowerCase() === 'unread'"
          ></div>
        </div>
      </div>
    </div>
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import { mapState } from "vuex";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import NotificationRequest from "@/model/requests/NotificationRequest.js";
export default {
  name: "Notifications",
  components: { TimeslotDashboardLayout },
  data() {
    return {
      updateModel: NotificationRequest.updateStatus
    };
  },
  computed: {
    ...mapState({
      notifications: state => state.notificationMessage.notifications,
      userInfo: state => state.auth.userInfo
    })
  },
  methods: {
    view(notification) {
      let notify = { notificationId: notification.notificationId };
      // this.updateModel.notificationId = "106";
      // this.updateModel.notificationId = notification.notificationId;
      // this.updateModel.notificationRecipient =
      //     notification.notificationRecipient;
      StoreUtils.dispatch("notificationMessage/updateStatus", notify).then(
        () => {
          let notify = { notificationRecipient: this.userInfo.customerId };
          StoreUtils.dispatch("notificationMessage/readNotifications", notify);
        }
      );
      if (notification.notificationModule.includes("Message")) {
        RouterUtils.changeRouteTo(RouterUtils.routes.auth.CUSTOMER_MESSAGES);
      }
      if (notification.notificationModule.includes("Subscription")) {
        RouterUtils.changeRouteTo(
          RouterUtils.routes.auth.CUSTOMER_SUBSCRIPTIONS
        );
      }
      if (notification.notificationModule.includes("Booking")) {
        RouterUtils.changeRouteTo(RouterUtils.routes.auth.CUSTOMER_BOOKINGS);
      }
    }
  }
};
</script>

<style scoped>
.notification-div {
  display: flex;
}
.unread {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #256ff6;
  /*margin-right: 30px;*/
}
.extra {
  display: flex;
  justify-content: space-between;
}
</style>
